export function copyToClipboard(elementToCopy) {
	var dummyElement = document.createElement("textarea");
	document.body.appendChild(dummyElement);
	dummyElement.value = elementToCopy;
	dummyElement.select();
	document.execCommand("copy");
	document.body.removeChild(dummyElement);
}
